const styleOverrides = {
  root: {
    padding: 0,
  },
};

export default styleOverrides;
